export default {
  SET_PAGINATION(state, data) {
    state.pagination = data
  },
  ADD_ROLE(state, role) {
    state.roles.push(role)
  },
  UPDATE_ROLE(state, role) {
    const roleIndex = state.roles.findIndex((e) => e.id === role.id)
    Object.assign(state.roles[roleIndex], role)
  },
  SET_ROLES(state, roles) {
    state.roles = roles
  },
  REMOVE_ROLE(state, itemId) {
    const roleIndex = state.roles.findIndex((u) => u.id === itemId)
    state.roles.splice(roleIndex, 1)
  },
  SET_PERMISSIONS(state, permissions) {
    state.permissions = permissions
  },
}
